import {observer} from "mobx-react";
import {useMemo} from "react";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR} from "../../../../components/fonts/font-props";
import {BUTTON_VARIANTS} from "../../../../components/inputs/button-variants";
import {IButtonProps} from "../../../../components/inputs/button/button";
import {SelectDropdown} from "../../../../components/inputs/select-dropdown/select-dropdown";
import {DefaultModalLayout} from "../../../../components/modal/layouts/default-modal-layout";
import SearchInput from "../../../../components/search-input/search-input";
import {IStoreLocation} from "../../../manage-returns/rma-page/rma-types";
import CreateRmaSettingsStore from "../../stores/create-rma-settings-store";
import PlatformProductSearchStore from "../../stores/platform-product-search-store";
import ProductOption from "./product-option";
import './product-search-modal.scss';

interface IProductSearchPopupProps {
    onClose: ()=>void;

}
const ProductSearchModal : React.FC<IProductSearchPopupProps> = observer(({onClose})=> {
    const store: PlatformProductSearchStore = useMemo(() => new PlatformProductSearchStore(new CreateRmaSettingsStore()), []);
    
    
    const buttons: IButtonProps[] = [
        {
            text: 'cancel',
            onClick: onClose,
            variant: BUTTON_VARIANTS.Transparent
        },
        {
            text: 'add',
            onClick: () => {
            },
            variant: BUTTON_VARIANTS.Primary
        },
    ];
    
    const locationSelectorOptions = (Object.values(store.locations) as IStoreLocation[]).map((location) => ({
        value: location.location_id,
        label: location.name
    }));
    
    const locationSelectorValue = locationSelectorOptions?.find(
        option => option.value === store.selectedlocationId
    );
    
    return (
        <DefaultModalLayout onCloseClicked={onClose} isCloseDisabled={false} buttons={buttons}>
            <div className={'product-search-modal'}>
                <FontBody2 color={FONT_COLOR.PRIMARY3_50}>New Item</FontBody2>
                <div className={'store-location'}>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>Store Location</FontBody2>
                    <SelectDropdown
                        placeholder={'Select Store Location'}
                        options={locationSelectorOptions}
                        value={locationSelectorValue}
                        onChange={v => store.setLocationId(v?.value as string)}
                        isLoading={store.isLoadingLocations}
                        disabled={false /* TODO: set disabled when physical user staff */}
                    />
                </div>
                <SearchInput onClick={store.search} onChange={store.setSearchInputText} isSearching={store.isSearching} placeholder={'Search for a product'} value={store.searchInputText}/>
                <div className={'product-search-results'}>
                    {store.productList.map(product => {
                        return (
                            <ProductOption key={product.id} product={product} productSearchStore={store}/>
                        )
                    })}
                </div>
            </div>
        </DefaultModalLayout>
    )
});

export default ProductSearchModal;